export const aboutUsInfo = {
  data: [
    {
      img: "/static/assets/icons/Hows.svg",
      title: "Hows",
      id: 1,
      label: "hows",
      image_2: "/static/assets/icons/Hows-2.svg",
      desc:
        "UNRWA's types of interventions ranging from capacity building, policy advice to thought leadership and innovation",
    },
    {
      img: "/static/assets/icons/Whos.svg",
      title: "Whos",
      id: 6,
      label: "whos",
      image_2: "/static/assets/icons/whos-2.svg",
      desc:
        "UNRWA's target beneficiaries to ensure no one is left behind and reach furthest behind geographically, socio-economically and due to shocks and fragility",
    },
    {
      img: "/static/assets/icons/Partner.svg",
      title: "Partner",
      id: 5,
      label: "partner",
      image_2: "/static/assets/icons/Partner-2.svg",
      desc:
        "UNRWA's wide range of partners to work together to achieve common development goals",
    },
    {
      img: "/static/assets/icons/South.png",
      title: "South-South and Triangular Cooperation",
      id: 3,
      label: "sstc",
      image_2: "/static/assets/icons/South-2.png",
      desc:
        "Connecting best knowledge, capacities and solutions across the countries we serve",
    },
    {
      img: "/static/assets/icons/JointPgm.png",
      title: "Joint Programme",
      id: 4,
      label: "joint programme",
      image_2: "/static/assets/icons/Jointpgm-2.png",
      desc:
        "Working with the United Nations System to address common development challenges",
    },
    {
      img: "/static/assets/icons/Humanitarian.png",
      title: "Humanitarian",
      label: "humanitarian",
      id: 2,
      image_2: "/static/assets/icons/Humanitarian-2.svg",
      desc:
        "UNRWA's response to disasters and crises to support efforts to return to sustainable development pathways",
    },
  ],
};



// WEBPACK FOOTER //
// ./static/assets/json/unrwaAboutUsData.js